import { handleAction, createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const setConnectedProduct = createAction('SET_CONNECTED_PRODUCT');

export const openIfitApps = createAction('OPEN_IFIT_APPS', () => {
  return getDataProvider().openIfitApps();
});

export const openAltraApp = createAction('OPEN_ALTRA_APP', () => {
  return getDataProvider().openAltraApp();
});

export const openSleepApp = createAction('OPEN_SLEEP_APP', () => {
  return getDataProvider().openSleepApp();
});

export const manualActivationCompleted = createAction('MANUAL_ACTIVATION_COMPLETED', () => {
  return getDataProvider().manualActivationCompleted();
});

export default handleAction(setConnectedProduct, (state, action) => action.payload, null);
